import axios from 'axios';
import { API_URL_NEW } from '../lib/endpoints';

const exportRequestApi = {

    createExportRequest: (payload = {}) => {
        const url = `${API_URL_NEW}/export-request`;

        return new Promise((resolve, reject) => {
            axios.post(url, payload)
                .then(
                    response => resolve(response)
                )
                .catch(
                    error => reject(error)
                );
        });
    }

}

export default exportRequestApi;